import React, { useState, useRef, useEffect } from "react";
import "./plugins/tinymce/plugins/code";
import "./plugins/tinymce/plugins/searchreplace";
import "./plugins/tinymce/plugins/searchreplace";
import "./plugins/tinymce/plugins/media";
import "./plugins/tinymce/plugins/autolink";
import "./plugins/tinymce/plugins/anchor";
import "./plugins/tinymce/plugins/lists";
import "./plugins/tinymce/plugins/visualchars";
import "./plugins/tinymce/plugins/visualblocks";
import "./plugins/tinymce/plugins/charmap";

import "./plugins/tinymce/tinymce.js";
import "./plugins/tinymce/icons/default/icons.js";
import "./plugins/tinymce/themes/silver/theme.js";
import "./plugins/tinymce/models/dom/model.js";
import "./plugins/tinymce/plugins/preview/plugin.js";
import "./plugins/tinymce/plugins/link/plugin.js";
import "./plugins/tinymce/plugins/image/plugin.js";
import "./plugins/tinymce/plugins/table/plugin.js";
import "./plugins/tinymce/plugins/wordcount/plugin.js";
import "./plugins/tinymce/skins/ui/oxide/skin.min.css";
import "./plugins/tinymce/skins/ui/oxide/content.min.css";
import "./plugins/tinymce/skins/content/default/content.min.css";
import { Editor } from "./plugins/@tinymce/tinymce-react";
import "@codecogs/eqneditor-tinymce6/eqneditor.js";
import { useLocation } from "react-router-dom";
import axios from "axios";
const EEDitor = (props) => {
  const [suggestions, setSuggestions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [wordIndex, setWordIndex] = useState(null);
  const handleKeyDown = (event) => {
    if (event.key === "ArrowDown") {
      setSelectedIndex((prevIndex) => (prevIndex + 1) % suggestions.length);
    } else if (event.key === "ArrowUp") {
      setSelectedIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : suggestions.length - 1
      );
    } else if (event.key === "Enter" && suggestions.length > 0) {
      applySuggestion(selectedIndex);
      event.preventDefault();
    }
  };
  const GetSuggestions = async (content, a) => {
    const selection = a.selection.getRng();

    if (!selection) return;

    const startOffset = selection.startOffset;
    const textNode = selection.startContainer;

    if (!textNode || textNode.nodeType !== 3) return;

    const text = textNode.nodeValue;
    let start = startOffset;
    let end = startOffset;
    while (start > 0 && /\w/.test(text[start - 1])) {
      start--;
    }

    while (end < text.length && /\w/.test(text[end])) {
      end++;
    }
    const words = content.replace(/&nbsp;/g, " ").split(" ");
    const word = text.substring(start, end);
    let charCount = 0;
    let editingIndex = null;
    for (let i = 0; i < words.length; i++) {
      charCount += words[i].length + 1;
      if (words[i] === word) {
        editingIndex = i;
        break;
      }
    }
    setWordIndex(editingIndex);
    if (!/\d/.test(word) && word.length > 0) {
      try {
        const response = await axios.get(
          `https://varnam.subinsb.com/tl/${props.LngValue || "hi" }/${word}`
        );
        setSuggestions(response.data.result || []);
        setSelectedIndex(0);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestions([]);
      }
    }
    // console.log("enter word", word);
  };

  const applySuggestion = (index) => {
    if (wordIndex === null) return;
    const words = props.PostValue.replace(/&nbsp;/g, " ").split(" ");
    words[wordIndex] = suggestions[index] + "&nbsp;";
    const updatedText = words.join(" ");
    props.onChange(updatedText);
    setSuggestions([]);
  };
  return (
    <>
      <div style={{ position: "relative" }}>
        <Editor
          disabled={props.disable}
          onKeyDown={handleKeyDown}
          init={{
            license_key: "gpl",
            skin: false,
            content_css: false,
            height: 300,

            file_picker_callback: (cb, value, meta) => {
              const input = document.createElement("input");
              input.setAttribute("type", "file");
              input.setAttribute("accept", "image/*");

              input.addEventListener("change", (e) => {
                const file = e.target.files[0];

                const reader = new FileReader();
                reader.addEventListener("load", () => {
                  const id = "blobid" + new Date().getTime();
                  const blobCache = tinymce.activeEditor.editorUpload.blobCache;
                  const base64 = reader.result.split(",")[1];
                  const blobInfo = blobCache.create(id, file, base64);
                  blobCache.add(blobInfo);

                  cb(blobInfo.blobUri(), { title: file.name });
                });
                reader.readAsDataURL(file);
              });

              input.click();
            },

            plugins: [
              "eqneditor",
              "link",
              "image",
              "table",
              "wordcount",
              "visualchars",
              "visualblocks",
              "charmap",
              "anchor",
              "preview",
              "code",
              "searchreplace",
              "media",
              "autolink",
              "lists",
            ],
            toolbar:
              " eqneditor | undo redo | styles | bold italic | forecolor backcolor | \
            alignleft aligncenter alignright alignjustify lists |  \
            bullist numlist outdent indent | link image  media | removeformat charmap | preview code searchreplace | \
            visualchars visualblocks | autolink | anchor  formatselect ",
          }}
          value={props.PostValue}
          onEditorChange={(content, event) => {
            if (props.onChange) {
              props.onChange(content);
            }
            if (props.Review) {
              GetSuggestions(content, event);
            }
          }}
        />

        {props.Review && suggestions.length > 0 && (
          <ul
            style={{
              backgroundColor: "white",
              border: "1px solid gray",
              listStyle: "none",
              padding: 0,
              // marginBottom: "5px",
              textAlign: "left",
              cursor: "pointer",
              overflowY: "auto",
              width: "300px",
              position: "absolute",
              top: 0,
              zIndex: 100,
              right: 0,
            }}
          >
            {suggestions.map((suggestion, index) => (
              <li
                key={index}
                onClick={() => applySuggestion(index)}
                style={{
                  padding: "3px",
                  backgroundColor: selectedIndex === index ? "#ddd" : "white",
                }}
              >
                {index + 1}: {suggestion}
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default EEDitor;
